import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import styles from './home-page.module.css';
import logo from '../logos/1.png';
import categoriesImage from './home-page-images/categories.png';
import realTimeSyncImage from './home-page-images/realtime-sync.png';
import pieChartImage from './home-page-images/piechart.png';
import barChartImage from './home-page-images/barchart.png';

export default ({ isAuthed }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if(isAuthed) {
            navigate('/app/at-a-glance');
        }
    }, [isAuthed, navigate]);

    return (
        <div className={styles.homePage}>
            <nav className={styles.topNav}>
                <div className={styles.navContent}>
                    <div className={styles.navLogoContainer}>
                        <Link to="/">
                            <img src={require('../logos/tiny1.png')} alt="Budget Butler" className={styles.navLogo} />
                        </Link>
                    </div>
                    <div className={styles.navLinks}>
                        { /* <Link to="/contact" className={styles.navLink}>Contact Us</Link> */ }
                        <Link to="/login" className={styles.loginButton}>Login</Link>
                        <Link to="/signup" className={styles.signupButton}>Sign Up</Link>
                    </div>
                </div>
            </nav>
            <div className={styles.mainContent}>
                <header className={styles.header}>
                    <div className={styles.headerContent}>
                        <div className={styles.logoContainer}>
                            <img src={logo} alt="Budget Butler Logo" className={styles.logo} />
                        </div>
                        <div className={styles.headerRight}>
                            <h2 className={styles.strapline}>Get a grip of your finances</h2>
                            <p className={styles.subtext}>Budget Butler helps you take control of your spending by categorizing and tracking your expenses, giving you true peace of mind.</p>
                            <Link to="/signup" className={styles.ctaButtonPrimary}>Sign Up</Link>
                        </div>
                    </div>
                </header>
            
                <section className={styles.featuresSection}>
                    <h2 className={styles.sectionTitle}>Features</h2>
                    <div className={styles.featuresGrid}>
                    <div className={styles.featureCard}>
                        <div className={styles.featureImageContainer}>
                            <img src={categoriesImage} alt="AI categorization" className={styles.featureImage} />
                        </div>
                        <h3>AI powered categorization</h3>
                        <p>Automatically categorize your spending using advanced AI, so that you do not need to.</p>
                    </div>
                    <div className={styles.featureCard}>
                        <div className={styles.featureImageContainer}>
                            <img src={realTimeSyncImage} alt="Bank connectivity" className={styles.featureImage} />
                        </div>
                        <h3>Bank Connectivity</h3>
                        <p>Instantly sync transactions from over 3,500 banks, ensuring your financial data is always up-to-date.</p>
                    </div>
                    <div className={styles.featureCard}>
                        <div className={styles.featureImageContainer}>
                            <img src={barChartImage} alt="Zero-setup" className={styles.featureImage} />
                        </div>
                        <h3>Zero-Setup Required</h3>
                        <p>Get insights immediately with no setup or manual configuration required.</p>
                    </div>
                    <div className={styles.featureCard}>
                        <div className={styles.featureImageContainer}>
                            <img src={pieChartImage} alt="Actionable insights" className={styles.featureImage} />
                        </div>
                        <h3>Actionable Insights & Charts</h3>
                        <p>Uncover trends and make smarter financial decisions with AI-powered charts and insights.</p>
                    </div>
                </div>
                </section>
            
                <section className={styles.safetySection}>
                    <h2 className={styles.sectionTitle}>Safety & Security</h2>
                    <div className={styles.safetyContainer}>
                        <div className={styles.safetyCard}>
                            <h3>Bank-Level Security</h3>
                            <p>Your financial data is protected with the latest encryption standards.</p>
                        </div>
                        <div className={styles.safetyCard}>
                            <h3>Data Retention</h3>
                            <p>We resync your data from your bank every time you visit, and do not retain it longer than 24hrs.</p>
                        </div>
                        <div className={styles.safetyCard}>
                            <h3>Privacy First</h3>
                            <p>We use FSA regulated Open Banking Providers for data access, and we never share your data.</p>
                        </div>
                    </div>
                </section>
            
                <div className={styles.ctaSection}>
                    <h2>Ready to get a grip of your finances?</h2>
                    <Link to="/signup" className={styles.ctaButton}>Sign Up</Link>
                </div>
            </div>
            
            <footer className={styles.footer}>
                <div className={styles.footerContent}>
                    <p>&copy; {new Date().getFullYear()} Budget Butler. All rights reserved.</p>
                    { /*
                    <div className={styles.footerLinks}>
                        <Link to="/terms">Terms</Link>
                        <Link to="/privacy">Privacy</Link>
                        <Link to="/contact">Contact Us</Link>
                    </div>
                    */ }
                </div>
            </footer>
        </div>
    );
}
